<template>
  <div class="study-rank">
    <chooseState :chooses="chooses"></chooseState>
    <studyTable :tableData="tableDataTemp" :pages="pages" :columns="columns"></studyTable>
  </div>
</template>
<script>
import chooseState from "./module/_studyChoose";
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      tableData: [],
      columns: [
        { name: "办事对象", prop: "c2name" },
        { name: "服务项目", prop: "c3name" },
        { name: "服务条数", prop: "count" }
      ],
      chooses: [
        { name: "低保政策" },
        { name: "医保政策" },
        { name: "社会救助政策" },
        { name: "惠农政策" },
        { name: "其他政策" }
      ],
      tableDataTemp: [],
      pages: 1,
      choosed: 1
    };
  },
  components: {
    chooseState,
    studyTable
  },
  methods: {
    getMsg() {
      this.tableDataTemp = [];
      this.axios
        .post("/api/Statistics/Service", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: sessionStorage.getItem("town"),
          c1status: this.choosed
        })
        .then(e => {
          switch (e.data.code) {
            case 0:
              this.tableData = e.data.msg;
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  this.tableDataTemp.push(item);
                }
              });
              this.pages = Number.parseInt(
                this.tableData.length % 10 > 0
                  ? this.tableData.length / 10 + 1
                  : this.tableData.length
              );
              console.log(this.pages);
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.study-rank {
  padding-top: 1.1rem;
  font-size: 0.3rem;
}
</style>